import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Add, RemoveRedEye } from '@mui/icons-material';
import { Box, Button, TableCell, TableRow, Typography, useTheme } from '@mui/material';
import { memo, useCallback, useContext, useMemo, useState } from 'react';
import { Z3KSettings, Z3KSettingsEditor } from '../../../provider/types';
import { getZ3kEntityById } from 'z3k-parser/lib/auxiliary';
import { useEditingProps, useGetZ3kObject } from '../../utils/unpack-props';
import { useActionDialog } from './action-dialog';
import { PriopityListSwitcher, priopityType } from './priopity-list-switcher';
import { findAndChangeLinks } from 'z3k-parser/lib/find-links';
import { useBox } from 'shared/hooks/utils';
function SelectionTableRowImpl(props) {
    const { title, help_id, z3k_field, z3k_name, options, notification, name_second_column, item_id, } = props;
    const { service_view } = useContext(Z3KSettings);
    const [ActionDialog, openActionDialog] = useActionDialog();
    const [priority_value, setPriorityValue] = useState(priopityType.event);
    const item = useGetZ3kObject(z3k_name);
    const id = (item_id ?? item.id);
    const { value, validation_result, validation_warnings_result, onChange } = useEditingProps(id, z3k_name, z3k_field);
    const onChangeItems = props.onChange ?? onChange;
    const theme = useTheme();
    const error = useMemo(() => validation_result != null, [validation_result]);
    const warning = useMemo(() => validation_result == null && validation_warnings_result != null, [validation_result, validation_warnings_result]);
    const is_validation_failed = useMemo(() => validation_result != null || validation_warnings_result != null, [validation_result, validation_warnings_result]);
    const { config, replace_config } = useContext(Z3KSettingsEditor);
    const boxed_config = useBox(config);
    const onClick = useCallback(() => {
        openActionDialog();
        let original_config = boxed_config.current;
        for (const item in value) {
            const [, z3k_object] = getZ3kEntityById(original_config, value[item]);
            if (z3k_object == null) {
                original_config = findAndChangeLinks(original_config, value[item]);
            }
        }
        replace_config(original_config);
    }, []);
    const count_elements = useMemo(() => {
        //@ts-ignore
        return value.length;
    }, [value]);
    return (_jsx(_Fragment, { children: _jsxs(TableRow, { sx: {
                '&:last-child td, &:last-child th': { border: 0 },
                ...(warning && {
                    backgroundColor: theme.palette.warning.light,
                    color: theme.palette.warning.contrastText,
                    '& .MuiSvgIcon-root, & .material-dnd': {
                        color: theme.palette.warning.contrastText,
                    },
                }),
                ...(error && {
                    backgroundColor: theme.palette.error.light,
                    color: theme.palette.error.contrastText,
                    '& .MuiSvgIcon-root, & .material-dnd': {
                        color: theme.palette.error.contrastText,
                    },
                }),
            }, children: [_jsx(TableCell, { component: "th", width: "33%", padding: "none", sx: { paddingX: 2 }, children: _jsx(Typography, { children: title }) }), notification && (_jsx(TableCell, { align: "center", padding: "none", sx: { paddingX: 1 }, children: _jsx(PriopityListSwitcher, { value: priority_value, onChange: setPriorityValue }) })), _jsx(TableCell, { align: "center", padding: "none", sx: { paddingX: 1 }, children: _jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", py: 1, children: [_jsx(Box, { display: "flex", alignItems: "center", justifyContent: "center", flexWrap: "wrap-reverse", children: _jsx(Button, { color: "primary", variant: "outlined", size: "small", onClick: onClick, endIcon: service_view ? (_jsx(Add, { color: 'primary' })) : (_jsx(RemoveRedEye, { color: !service_view && count_elements == 0
                                            ? 'disabled'
                                            : 'primary' })), disabled: !service_view && count_elements == 0, children: count_elements > 0
                                        ? `Выбрано: ${count_elements}`
                                        : 'Не выбрано' }, count_elements) }), is_validation_failed && (_jsx(Typography, { variant: "subtitle2", sx: {
                                    ...(warning && {
                                        color: theme.palette.warning.contrastText,
                                    }),
                                    ...(error && {
                                        color: theme.palette.error.contrastText,
                                    }),
                                }, children: validation_result ??
                                    validation_warnings_result }))] }) }), _jsx(ActionDialog, { value: value, help_id: help_id, options: options, validation_result: validation_result, validation_warnings_result: validation_warnings_result, onChange: onChangeItems, name_second_column: name_second_column })] }, title) }));
}
export const SelectionTableRow = memo(SelectionTableRowImpl);
